/* src/app/vehicle/pages/vehicles-vor-new/vehicles-vor-new.component.scss */
/*# sourceMappingURL=vehicles-vor-new.component.css.map */
